/**
 * Helper para usar i18n fora de componentes Vue (stores, services, utils)
 * Importa a instância global do i18n e expõe a função t()
 */
import { getI18n } from '@/i18n'
import { STORAGE_KEYS } from '@/utils/storageKeys'

function resolveI18n() {
  try {
    return getI18n()
  } catch {
    return null
  }
}

function fallbackLocale() {
  if (typeof localStorage === 'undefined') return 'pt-BR'
  return localStorage.getItem(STORAGE_KEYS.LOCALE) || 'pt-BR'
}

/**
 * Traduz uma chave i18n usando a instância global
 * @param {string} key - Chave de tradução (ex: 'errors.generic')
 * @param {object} params - Parâmetros para interpolação
 * @returns {string} Texto traduzido
 */
export function t(key, params) {
  const i18n = resolveI18n()
  if (!i18n) return key
  return i18n.global.t(key, params)
}

/**
 * Retorna o locale atual
 * @returns {string} Locale atual (ex: 'pt-BR', 'en-US', 'es')
 */
export function getCurrentLocale() {
  const i18n = resolveI18n()
  if (i18n) return i18n.global.locale.value
  return fallbackLocale()
}
